function removeStyle(element: HTMLElement, data: string | string[]): void {
    // If data is string
    if (typeof data === 'string') {
        data = data.split(' ');
    }

    // Foreach Data
    for (const item of data) {
        element.style.removeProperty(item);
    }
}

// ----------------------------------------------------------------------------

export default removeStyle;
